module.exports = __webpack_public_path__ + "img/76149.264f86e2.svg";